import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary, Grid, TextField, Typography } from "@mui/material";
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMore';

interface ProcurerAccordionDetailProps {
    detail: any,
    isDisabled: boolean
}

const ProcurerAccordionDetail = ({ detail, isDisabled }: ProcurerAccordionDetailProps) => {
    const { t } = useTranslation(['salesmarketing', 'translation']);
    const { t : type } = useTranslation(['servicetype', 'translation']);

    return (
        <>
            <Accordion defaultExpanded={true}>
                <AccordionSummary expandIcon={<ExpandMoreRoundedIcon />}>
                    <Typography>{t('salesmarketing:procurer.detailContent.generalInfoSummary')}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={1}>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.namingField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.naming}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.serviceTypeField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail.serviceType.length > 0 ? detail.serviceType.map((s:string)=>s.includes('|') ? type(s.split('|')[0].replace(":", "-")) : s).join(', '): ''}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.countryField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.country}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.regionField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.region && detail?.region.split('|').length >1 ? detail?.region.split('|')[1] : detail?.region }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.provinceField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.province}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.cityField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.city}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.addressField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.address}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.streetNumberField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.streetNumber}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.postalCodeField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.postalCode}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.areaField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.area && detail?.area.split('|').length >1 ? detail?.area.split('|')[1] : detail?.area }
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.phoneNumberField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.phoneNumber}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.cellPhoneNumberField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.cellPhoneNumber}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.emailField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.email}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.acgCodeField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.finOldIdentificationCode}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.dmsField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.dms}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.agreementDateField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.agreementDate}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.affIncomeCodeField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.affIncomeCode ? detail?.affIncomeCode : '--' }
                            />
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            <Accordion>
                <AccordionSummary expandIcon={<ExpandMoreRoundedIcon />}>
                    <Typography>{t('salesmarketing:affiliate.detailContent.representativeInfoSummary')}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={1}>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.representativeNameField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeName}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.representativeEmailField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeEmail}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.representativeCellphoneField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeCellphone}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.representativeIbanField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeIban}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.representativeProvinceField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeProvince}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.representativeCityField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeCity}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.representativeAddressField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeAddress}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.representativeStreetNumberField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeStreetNumber}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.representativePostalCodeField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativePostalCode}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.representativeHqCellphoneField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativeHqCellphone}
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                fullWidth
                                label={t('salesmarketing:procurer.detailContent.representativePecField')}
                                inputProps={{
                                    readOnly: !isDisabled
                                }}
                                disabled={isDisabled}
                                value={detail?.representativePec}
                            />
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </>
    );
}

export default ProcurerAccordionDetail;